const socialLinks = [
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/profile.php?id=61591592757996#',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true" className="h-5 w-5">
        <path
          fill="currentColor"
          d="M14.2 8.4V6.9c0-.7.5-1.2 1.3-1.2h1.7V2.6c-.3 0-1.5-.1-2.8-.1-2.8 0-4.7 1.7-4.7 4.8v1.1H6.8v3.5h2.9v8.6h3.6v-8.6h2.9l.5-3.5h-3Z"
        />
      </svg>
    ),
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/aelofilter/',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true" className="h-5 w-5">
        <path
          fill="currentColor"
          d="M7.8 2.5h8.4c2.9 0 5.3 2.4 5.3 5.3v8.4c0 2.9-2.4 5.3-5.3 5.3H7.8c-2.9 0-5.3-2.4-5.3-5.3V7.8c0-2.9 2.4-5.3 5.3-5.3Zm0 1.9c-1.9 0-3.4 1.5-3.4 3.4v8.4c0 1.9 1.5 3.4 3.4 3.4h8.4c1.9 0 3.4-1.5 3.4-3.4V7.8c0-1.9-1.5-3.4-3.4-3.4H7.8Zm4.2 3.1a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm0 1.9a2.6 2.6 0 1 0 0 5.2 2.6 2.6 0 0 0 0-5.2Zm5-2.3a1.1 1.1 0 1 1 0 2.2 1.1 1.1 0 0 1 0-2.2Z"
        />
      </svg>
    ),
  },
  {
    label: 'TikTok',
    href: 'https://www.tiktok.com/@aelofilter.com',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true" className="h-5 w-5">
        <path
          fill="currentColor"
          d="M16.6 2.5c.3 2.2 1.6 3.7 3.8 3.9v3.4a7.3 7.3 0 0 1-3.7-1.1v5.6c0 4.2-2.4 7.2-6.4 7.2a6.1 6.1 0 0 1-6.2-6.2c0-3.8 3.1-6.6 7-6.1v3.6c-1.8-.3-3.4.7-3.4 2.5 0 1.5 1.1 2.6 2.6 2.6 1.8 0 2.7-1.1 2.7-3.4v-12h3.6Z"
        />
      </svg>
    ),
  },
]

export default function Footer() {
  return (
    <footer className="border-t border-aelo-mist bg-aelo-snow">
      <div className="aelo-container py-10">
        <div className="flex flex-col items-center gap-6">
          <div className="flex w-full flex-col items-center justify-between gap-4 md:flex-row">
            <a
              href="/"
              aria-label="Aelo home"
              className="flex min-h-11 items-center gap-2 rounded-md px-2 transition-opacity hover:opacity-70 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-aelo-water"
            >
              <img src="/assets/aelo-logo.png?v=20260509b" alt="Aelo" className="h-6 w-auto" />
            </a>
          <p className="text-center text-sm text-aelo-silver">
            &copy; {new Date().getFullYear()} Aelo. Pre-launch.
          </p>
          <div className="flex gap-6 text-sm text-aelo-slate">
            <a href="/privacy" className="hover:text-aelo-black transition-colors">Privacy</a>
            <a href="/terms" className="hover:text-aelo-black transition-colors">Terms</a>
          </div>
          </div>
          <nav aria-label="Aelo social media" className="flex items-center justify-center gap-3">
            {socialLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Aelo on ${link.label}`}
                className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-aelo-mist bg-white text-aelo-black shadow-sm transition-colors hover:border-aelo-water hover:bg-aelo-water-muted focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-aelo-water"
              >
                {link.icon}
              </a>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  )
}
